import { render, staticRenderFns } from "./EddSettings.vue?vue&type=template&id=2ff094de&"
import script from "./EddSettings.vue?vue&type=script&lang=js&"
export * from "./EddSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports